// information from firebase that tells app where database is and what's in it
const firebaseConfig = {
    apiKey: "AIzaSyCN5Zf6eFJNrwqQRMA5wKKcScyqy0BL-aE",
    authDomain: "fir-team43.firebaseapp.com",
    databaseURL: "https://fir-team43.firebaseio.com",
    projectId: "fir-team43",
    storageBucket: "fir-team43.appspot.com",
    messagingSenderId: "23656823046",
    appId: "1:23656823046:web:7be2257238aaaa4c450687",
    measurementId: "G-HJTH1FYZMX"
  };

export default firebaseConfig;